// externals
import type { Reducer } from 'redux';

// libraries
import type { BootstrapState } from '@makemydeal/dr-dash-types';

// interfaces/types
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { applicationLoadErrorActionTypes, bootstrapActionTypes, initActionTypes } from '@makemydeal/dr-shared-store';
import {
    DASH_MENU_LIFECYCLE_INIT_FINISH,
    DASH_MENU_LIFECYCLE_INIT_START,
    DASH_MENU_SKIPPED
} from '../actionTypes/vehicleProtectionActionTypes';

export type BootstrapReducer = Reducer<BootstrapState>;

export const BOOTSTRAP_INITIAL_STATE: BootstrapState = {
    lazyInitCompleted: false
};

export const reducer: Reducer<BootstrapState> = (state: BootstrapState = BOOTSTRAP_INITIAL_STATE, action: AnyFSA) => {
    switch (action.type) {
        case applicationLoadErrorActionTypes.APPLICATION_LOAD_ERROR: {
            return {
                ...state,
                lazyInitCompleted: false
            };
        }
        case bootstrapActionTypes.BOOTSTRAP_REQUEST: {
            return { ...state, lazyInitCompleted: false };
        }
        case bootstrapActionTypes.BOOTSTRAP_FAILURE: {
            return {
                ...state,
                lazyInitCompleted: false
            };
        }
        case DASH_MENU_LIFECYCLE_INIT_START: {
            return {
                ...state,
                lazyInitCompleted: false
            };
        }
        case DASH_MENU_SKIPPED:
        case DASH_MENU_LIFECYCLE_INIT_FINISH: {
            return {
                ...state,
                lazyInitCompleted: true
            };
        }
        case initActionTypes.INIT_SUCCESS: {
            return {
                ...state,
                initSuccessCount: (state.initSuccessCount ?? 0) + 1
            };
        }
        default: {
            return state;
        }
    }
};
